
import React, { createContext, useContext, useState, useEffect } from "react";

// Context 생성
const AuthContext = createContext();

// Context Provider 컴포넌트
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    // 로그인 함수
    const login = (userData) => {
        setUser(userData);  // 상태 업데이트
        localStorage.setItem("user", JSON.stringify(userData)); // 로컬스토리지 저장
    };

    // 로그아웃 함수
    const logout = () => {
        setUser(null);
        localStorage.removeItem("user"); // 로컬스토리지에서 제거
    };

    // 컴포넌트가 처음 마운트될 때 로컬스토리지에서 유저 정보를 불러옴
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Context 사용 훅
export const useAuth = () => useContext(AuthContext);
